import { UserRole } from '../types/User.model';
import { createApiClient } from '../utils/createApiClient';
import type {
  User as Auth0User,
  Auth0ContextInterface,
} from '@auth0/auth0-react';

// Unique query definitions, only queries
// that uses react query directly and does not
// get wrapped with createQuery. All other queries
// are wrapped with createQuery and are passed the session user object.

export function getIdentitySessionQuery(token?: string) {
  return {
    queryKey: ['/session'],
    queryFn: async () => {
      if (!token) throw new Error('No token');
      const api = await createApiClient({ token });

      try {
        const res = await api.get(`/identity/session`);

        if (!res.embedded?.user) return null;

        const { user } = res.embedded;

        return {
          ...user,
          isAdmin: user.userRole === UserRole.ADMIN,
          isFund: user.userRole === UserRole.FUND,
          isCompany: user.userRole === UserRole.COMPANY,
        };
      } catch (e) {
        console.error('Error in getIdentitySessionQuery:', {
          error: e,
        });
        throw e;
      }
    },
  };
}

export function getAccessToken(auth0Session: Auth0ContextInterface<Auth0User>) {
  return {
    queryKey: ['auth0/getAccessTokenSilently'],
    queryFn: async () => {
      return await auth0Session.getAccessTokenSilently();
    },
  };
}
